<template>
  <div class="custom-scroll-wrapper">
    <div v-if="!loading">
      <div>
        <v-row no-gutters class="sticky-header">
          <v-col cols="12">
            <v-card
              elevation="0"
              style="
                border-bottom: 2px solid rgba(0, 0, 0, 0.1);
                display: flex;
                justify-content: space-between;
              "
            >
              <v-card-title style="margin: 0; padding: 3px 0 2px 0">
                <p
                  class="text-h6 font-weight-bold text-left text-uppercase"
                  style="margin: 0; position: relative; top: -10px"
                >
                  Detail Pemeriksaan & Pengkajian Masalah/ Keadaan Darurat
                  <v-tooltip bottom color="grey">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        x-small
                        text
                        icon
                        color="grey darken-2"
                        @click="getDataFromApi"
                        style="position: relative; top: -3px"
                      >
                        <v-icon small>mdi-refresh</v-icon>
                      </v-btn>
                    </template>
                    <span>refresh page</span>
                  </v-tooltip>
                </p>
                <p
                  v-if="detailData != null"
                  style="
                    position: absolute;
                    bottom: -25px;
                    left: -2px;
                    font-weight: bold;
                    padding-left: 3px;
                    font-size: 14px;
                  "
                >
                  {{ detailData.document_no }}
                </p>
              </v-card-title>
              <v-card-actions class="actionButton">
                <div
                  v-if="detailData != null"
                  style="
                    position: absolute;
                    bottom: 2px;
                    right: 0;
                    border: 1px solid black;
                  "
                >
                  <p
                    :style="`background-color: ${initialStatusColor(
                      detailData.status
                    )};
                color: white;
                font-weight: bold;
                width: 180px;
                text-align: center;
                margin:0`"
                  >
                    {{ detailData.status.name }}
                  </p>
                </div>
              </v-card-actions>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card elevation="0" v-if="detailData != null">
              <v-card-text style="padding: 5px 0; margin: 0">
                <p
                  style="
                    position: absolute;
                    top: -2px;
                    left: -2px;
                    font-weight: bold;
                    padding-left: 4px;
                    font-size: 12px;
                  "
                >
                  Tgl. Buat: {{ detailData.created_at }} |
                  {{ detailData.created_by_name }}
                </p>
              </v-card-text>
              <v-card-actions
                v-if="
                  getUserProfile.level.find(
                    ({ id }) =>
                      id == appLevel.adminK3 ||
                      id == appLevel.picK3 ||
                      id == appLevel.administrator
                  ) != undefined
                "
              >
                <div
                  v-if="!isEdit"
                  class="d-flex"
                  style="
                    position: absolute;
                    top: 0;
                    right: 0;
                    padding-left: 2px;
                  "
                >
                  <div v-if="detailData.status.id == 0">
                    <v-btn
                      style="font-weight: bold"
                      x-small
                      text
                      outlined
                      color="primary"
                      @click.prevent="enableEdit"
                    >
                      <v-icon
                        x-small
                        color="primary"
                        style="position: relative; top: 1px"
                      >
                        mdi-pencil
                      </v-icon>
                      Edit Header
                    </v-btn>
                    <v-btn
                      style="font-weight: bold; margin-left: 5px"
                      x-small
                      text
                      outlined
                      color="success"
                      @click="submitReportDocument"
                    >
                      SUBMIT
                    </v-btn>
                  </div>
                  <div v-if="detailData.status.id != 2">
                    <v-btn
                      style="font-weight: bold; margin-left: 5px"
                      x-small
                      text
                      outlined
                      color="red"
                      @click="cancelReportDocument"
                    >
                      CANCEL
                    </v-btn>
                  </div>
                  <!-- <div v-if="detailData.status.id == 1">
                    <div v-if="isAllowApprove">
                      <v-btn
                        style="font-weight: bold; margin-left: 5px"
                        x-small
                        text
                        outlined
                        color="success"
                        @click="confirmReportDocument"
                      >
                        CONFIRM
                      </v-btn>
                      <v-btn
                        style="font-weight: bold; margin-left: 5px"
                        x-small
                        text
                        outlined
                        color="red"
                        @click="rejectReportDocument"
                      >
                        REJECT
                      </v-btn>
                    </div>
                  </div> -->
                  <div v-if="detailData.status.id == 2">
                    <v-btn
                      style="font-weight: bold; margin-left: 5px"
                      x-small
                      text
                      outlined
                      color="primary"
                      @click="setDraftReport"
                    >
                      SET DRAFT
                    </v-btn>
                  </div>
                </div>

                <div
                  v-else
                  style="
                    position: absolute;
                    top: 0;
                    right: 0px;
                    padding-left: 2px;
                  "
                >
                  <v-btn
                    style="font-weight: bold"
                    x-small
                    text
                    outlined
                    color="primary"
                    type="button"
                    @click="saveForm"
                  >
                    <v-icon
                      x-small
                      color="primary"
                      style="position: relative; top: 1px"
                    >
                      mdi-content-save-edit-outline
                    </v-icon>
                    Save
                  </v-btn>
                  <v-btn
                    style="font-weight: bold; margin-left: 10px"
                    x-small
                    text
                    outlined
                    color="red"
                    @click="enableEdit"
                  >
                    <v-icon
                      x-small
                      color="red"
                      style="position: relative; top: 1px"
                    >
                      mdi-cancel
                    </v-icon>
                    Cancel
                  </v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="detailData != null" no-gutters class="my-5">
          <v-expansion-panels
            v-model="panel"
            focusable
            multiple
            tile
            class="mt-1"
          >
            <v-expansion-panel
              v-for="(item, index) in inspectionSection"
              :key="index"
            >
              <v-expansion-panel-header color="#ccdbdc">
                <p style="font-weight: bold; margin: 0">
                  {{ toRoman(index + 1) }}. {{ item.toUpperCase() }}
                </p>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div
                  v-if="index == 0"
                  style="min-height: 40vh; margin-top: 15px"
                >
                  <v-card elevation="0">
                    <v-form
                      ref="inspectionReportFormRef"
                      :readonly="!isEdit"
                      @submit.prevent="saveForm"
                      style="margin-top: 10px"
                    >
                      <div>
                        <v-row>
                          <v-col
                            v-if="!isEdit"
                            cols="12"
                            md="4"
                            class="d-flex flex-column"
                          >
                            <p
                              class="text-left"
                              style="
                                margin: 0;
                                font-size: 12px;
                                font-weight: bold;
                                color: rgba(0, 0, 0, 0.5);
                              "
                            >
                              Laporan Awal Insiden
                            </p>
                            <v-text-field
                              :value="detailData.initialreport.document_no"
                              dense
                              readonly
                              style="height: 15px"
                            />
                          </v-col>
                          <v-col
                            v-if="!isEdit"
                            cols="12"
                            md="4"
                            class="d-flex flex-column"
                          >
                            <p
                              class="text-left"
                              style="
                                margin: 0;
                                font-size: 12px;
                                font-weight: bold;
                                color: rgba(0, 0, 0, 0.5);
                              "
                            >
                              No. Dokumen
                            </p>
                            <v-text-field
                              :value="detailData.document_no"
                              dense
                              readonly
                              style="height: 15px"
                            />
                          </v-col>
                          <v-col
                            v-if="!isEdit"
                            cols="12"
                            md="4"
                            class="d-flex flex-column"
                          >
                            <p
                              class="text-left"
                              style="
                                margin: 0;
                                font-size: 12px;
                                font-weight: bold;
                                color: rgba(0, 0, 0, 0.5);
                              "
                            >
                              Perusahaan
                            </p>
                            <v-text-field
                              :value="detailData.initialreport.company_name"
                              dense
                              readonly
                              style="height: 15px"
                            />
                          </v-col>
                          <v-col
                            v-if="!isEdit"
                            cols="12"
                            md="4"
                            class="d-flex flex-column"
                          >
                            <p
                              class="text-left"
                              style="
                                margin: 0;
                                font-size: 12px;
                                font-weight: bold;
                                color: rgba(0, 0, 0, 0.5);
                              "
                            >
                              Lokasi Kejadian
                            </p>
                            <v-text-field
                              :value="
                                initialreport.incident_location != null
                                  ? initialreport.incident_location.name
                                  : null
                              "
                              dense
                              readonly
                              style="height: 15px"
                            />
                          </v-col>
                          <v-col
                            v-if="!isEdit"
                            cols="12"
                            md="4"
                            class="d-flex flex-column"
                          >
                            <p
                              class="text-left"
                              style="
                                margin: 0;
                                font-size: 12px;
                                font-weight: bold;
                                color: rgba(0, 0, 0, 0.5);
                              "
                            >
                              Tgl Kejadian
                            </p>
                            <v-text-field
                              :value="initialreport.incident_date"
                              dense
                              readonly
                              style="height: 15px"
                              type="date"
                              append-icon="mdi-calendar"
                            />
                          </v-col>
                          <v-col
                            v-if="!isEdit"
                            cols="12"
                            md="4"
                            class="d-flex flex-column"
                          >
                            <p
                              class="text-left"
                              style="
                                margin: 0;
                                font-size: 12px;
                                font-weight: bold;
                                color: rgba(0, 0, 0, 0.5);
                              "
                            >
                              Waktu Kejadian
                            </p>
                            <v-text-field
                              dense
                              :value="initialreport.incident_time"
                              readonly
                              style="height: 15px"
                              type="time"
                            />
                          </v-col>

                          <v-col
                            v-if="!isEdit"
                            cols="12"
                            md="4"
                            class="d-flex flex-column"
                          >
                            <p
                              class="text-left"
                              style="
                                margin: 0;
                                font-size: 12px;
                                font-weight: bold;
                                color: rgba(0, 0, 0, 0.5);
                              "
                            >
                              Tgl Laporan Diterima
                            </p>
                            <v-text-field
                              dense
                              :value="
                                initialreport.reported_date
                                  | moment('YYYY-MM-DD')
                              "
                              style="height: 15px"
                              type="date"
                              append-icon="mdi-calendar"
                            />
                          </v-col>
                          <v-col cols="12" md="4" class="d-flex flex-column">
                            <p
                              class="text-left"
                              style="
                                margin: 0;
                                font-size: 12px;
                                font-weight: bold;
                                color: rgba(0, 0, 0, 0.5);
                              "
                            >
                              Tgl Pemeriksaan *
                            </p>
                            <v-text-field
                              v-model="detailData.investigation_date"
                              dense
                              :clearable="isEdit"
                              :outlined="isEdit"
                              style="height: 15px"
                              :append-icon="isEdit ? '' : 'mdi-calendar'"
                              type="date"
                            />
                          </v-col>
                          <v-col cols="12" md="4" class="d-flex flex-column">
                            <p
                              class="text-left"
                              style="
                                margin: 0;
                                font-size: 12px;
                                font-weight: bold;
                                color: rgba(0, 0, 0, 0.5);
                              "
                            >
                              Klasifikasi Kecelakaan *
                              <v-tooltip right color="primary" top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    color="primary"
                                    x-small
                                  >
                                    mdi-information
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    detailData.accident_classification != null
                                      ? detailData.accident_classification
                                          .description
                                      : null
                                  }}
                                </span>
                              </v-tooltip>
                            </p>
                            <v-autocomplete
                              v-model="detailData.accident_classification"
                              :clearable="isEdit"
                              :outlined="isEdit"
                              :readonly="!isEdit"
                              :items="dropdown.accidentclassification"
                              item-text="name"
                              item-value="id"
                              return-object
                              dense
                              style="height: 15px"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" v-if="isEdit"></v-col>
                          <v-col cols="12" md="4" class="d-flex flex-column">
                            <p
                              class="text-left"
                              style="
                                margin: 0;
                                font-size: 12px;
                                font-weight: bold;
                                color: rgba(0, 0, 0, 0.5);
                              "
                            >
                              Jml Jam Kerja Perhari *
                            </p>
                            <v-text-field
                              v-model="detailData.total_working_hours"
                              dense
                              :clearable="isEdit"
                              :outlined="isEdit"
                              :readonly="!isEdit"
                              type="number"
                              min="0"
                              style="height: 15px"
                            />
                          </v-col>
                          <v-col
                            v-if="
                              detailData.accident_classification != null &&
                              detailData.accident_classification.id == 3
                            "
                            cols="12"
                            md="4"
                            class="d-flex flex-column"
                          >
                            <p
                              class="text-left"
                              style="
                                margin: 0;
                                font-size: 12px;
                                font-weight: bold;
                                color: rgba(0, 0, 0, 0.5);
                              "
                            >
                              Jml Hari Orang yang Hilang
                            </p>
                            <v-text-field
                              v-model="detailData.total_missing_hours"
                              dense
                              :clearable="isEdit"
                              :outlined="isEdit"
                              :readonly="!isEdit"
                              type="number"
                              min="0"
                              style="height: 15px"
                            />
                          </v-col>

                          <v-col
                            v-if="!isEdit"
                            cols="11"
                            class="d-flex flex-column"
                          >
                            <p
                              class="text-left"
                              style="
                                margin: 0;
                                font-size: 12px;
                                font-weight: bold;
                                color: rgba(0, 0, 0, 0.5);
                              "
                            >
                              Kronologi Kejadian Awal
                            </p>
                            <v-textarea
                              :value="detailData.initialreport.chronology"
                              dense
                              :rows="5"
                              :auto-grow="true"
                              readonly
                            />
                          </v-col>
                          <!-- <v-col cols="12" md="4" class="d-flex flex-column">
                              <p
                                class="text-left"
                                style="
                                  margin: 0;
                                  font-size: 12px;
                                  font-weight: bold;
                                  color: rgba(0, 0, 0, 0.5);
                                "
                              >
                                Due Date Perbaikan
                              </p>
                              <v-text-field
                                dense
                                :outlined="isEdit"
                                :clearable="isEdit"
                                style="height: 15px"
                                type="date"
                              />
                            </v-col> -->
                        </v-row>
                      </div>
                    </v-form>
                  </v-card>
                </div>
                <div
                  v-else-if="index == 1"
                  style="min-height: 40vh; margin-top: 15px"
                >
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="4" md="3" class="d-flex flex-column">
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Korban laki-laki
                          </p>
                          <v-text-field
                            dense
                            :value="initialreport.victim.lakiLaki"
                            readonly
                            style="height: 45px"
                          />
                        </v-col>
                        <v-col cols="4" md="3" class="d-flex flex-column">
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Korban perempuan
                          </p>
                          <v-text-field
                            :value="initialreport.victim.perempuan"
                            dense
                            readonly
                            style="height: 45px"
                          />
                        </v-col>
                        <v-col cols="4" md="2" class="d-flex flex-column">
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Meninggal Dunia
                          </p>
                          <v-text-field
                            :value="initialreport.victim.meninggalDunia"
                            dense
                            readonly
                            style="height: 45px"
                          />
                        </v-col>
                        <v-col cols="4" md="2" class="d-flex flex-column">
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Luka berat
                          </p>
                          <v-text-field
                            :value="initialreport.victim.lukaBerat"
                            dense
                            readonly
                            style="height: 45px"
                          />
                        </v-col>
                        <v-col cols="4" md="2" class="d-flex flex-column">
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Luka ringan
                          </p>
                          <v-text-field
                            :value="initialreport.victim.lukaRingan"
                            dense
                            readonly
                            style="height: 45px"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <div
                        v-if="
                          detailData != null &&
                          detailData.status.id == 0 &&
                          getUserProfile.level.find(
                            ({ id }) =>
                              id == appLevel.adminK3 ||
                              id == appLevel.picK3 ||
                              id == appLevel.administrator
                          ) != undefined
                        "
                        class="position-relative z-0"
                      >
                        <v-btn
                          @click="addNewPersonInvolve"
                          color="blue darken-1"
                          type="button"
                          small
                          outlined
                          class="white--text"
                        >
                          + Korban/Saksi
                        </v-btn>
                        <v-btn
                          @click="addNewBrokenObject"
                          color="blue darken-1"
                          type="button"
                          small
                          outlined
                          class="white--text ml-5"
                        >
                          + Kerusakan Object
                        </v-btn>
                      </div>
                    </v-col>

                    <v-col cols="12">
                      <v-card elevation="1" class="mt-10">
                        <div
                          class="d-flex"
                          style="
                            position: absolute;
                            top: -19px;
                            left: 2px;
                            z-index: 3;
                          "
                        >
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 13px;
                              font-weight: bold;
                              text-transform: uppercase;
                            "
                          >
                            Data Korban
                          </p>
                        </div>
                        <v-data-table
                          mobile-breakpoint="0"
                          fixed-header
                          :items="victimData"
                          :headers="victimHeaders"
                          @click:row="personInvovleRowClick"
                          style="cursor: pointer"
                          :loading="loading"
                          :items-per-page="-1"
                          hide-default-footer
                        >
                          <template v-slot:[`item.name`]="{ item }">
                            <div
                              style="
                                width: 120px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.name }}
                            </div>
                          </template>
                          <template v-slot:[`item.birth_date`]="{ item }">
                            <div
                              style="
                                width: 70px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.birth_date }}
                            </div>
                          </template>
                          <template v-slot:[`item.age`]="{ item }">
                            <div
                              style="
                                width: 70px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ calculateAge(item.birth_date) }}th
                            </div>
                          </template>
                          <template v-slot:[`item.gender`]="{ item }">
                            <div
                              style="
                                width: 70px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{
                                item.gender == 1
                                  ? 'Laki-laki'
                                  : item.gender == 2
                                  ? 'Perempuan'
                                  : '-'
                              }}
                            </div>
                          </template>
                          <template v-slot:[`item.no_identitas`]="{ item }">
                            <div
                              style="
                                width: 70px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.no_identitas }}
                            </div>
                          </template>
                          <template v-slot:[`item.person_type`]="{ item }">
                            <div
                              style="
                                width: 70px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{
                                item.person_type == 1
                                  ? 'Karyawan'
                                  : item.person_type == 2
                                  ? 'Non Karyawan'
                                  : '-'
                              }}
                            </div>
                          </template>
                          <template
                            v-slot:[`item.employee_leader_name`]="{ item }"
                          >
                            <div
                              style="
                                width: 140px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.employee_leader_name }}
                            </div>
                          </template>
                          <template v-slot:[`item.injured_category`]="{ item }">
                            <div
                              style="
                                width: 80px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{
                                item.injured_category != null
                                  ? item.injured_category.name
                                  : '-'
                              }}
                            </div>
                          </template>

                          <template v-slot:[`item.body_part`]="{ item }">
                            <div
                              style="
                                width: 210px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                                overflow: auto;
                              "
                            >
                              <v-chip
                                v-for="(obj, idx) in item.injured_body_part_id"
                                :key="idx"
                                label
                                outlined
                                small
                                style="
                                  position: relative;
                                  margin-right: 5px;
                                  padding: 0 3px;
                                  cursor: pointer;
                                  border: 1px solid rgba(0, 0, 0, 0.5);
                                "
                              >
                                {{ getBodyPartName(obj) }}
                              </v-chip>
                            </div>
                          </template>
                          <template v-slot:[`item.machine_used`]="{ item }">
                            <div
                              style="
                                width: 80px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.machine_used }}
                            </div>
                          </template>
                          <template v-slot:[`item.amount_loss`]="{ item }">
                            <div
                              style="
                                width: 60px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.amount_loss }}
                            </div>
                          </template>
                          <template
                            v-slot:[`item.rehabilitation_days`]="{ item }"
                          >
                            <div
                              style="
                                width: 60px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.rehabilitation_days }}
                              {{ item.engagement_type == 1 ? ' Hari' : '' }}
                            </div>
                          </template>
                          <template v-slot:[`item.company_name`]="{ item }">
                            <div
                              style="
                                min-width: 180px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.company_name }}
                            </div>
                          </template>
                          <template v-slot:[`item.department_name`]="{ item }">
                            <div
                              style="
                                min-width: 180px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.department_name }}
                            </div>
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <div
                              style="
                                width: 15px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                              "
                            >
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    color="error"
                                    @click.stop="deletePersonInvolve(item)"
                                  >
                                    mdi-delete
                                  </v-icon>
                                </template>
                                <span>Delete</span>
                              </v-tooltip>
                            </div>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-col>

                    <v-col cols="12">
                      <v-card elevation="1" class="mt-10">
                        <div
                          class="d-flex"
                          style="
                            position: absolute;
                            top: -19px;
                            left: 2px;
                            z-index: 3;
                          "
                        >
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 13px;
                              font-weight: bold;
                              text-transform: uppercase;
                            "
                          >
                            Data Saksi
                          </p>
                        </div>
                        <v-data-table
                          mobile-breakpoint="0"
                          fixed-header
                          :items="witnessData"
                          :headers="witnessHeaders"
                          @click:row="personInvovleRowClick"
                          style="cursor: pointer"
                          :loading="loading"
                          :items-per-page="-1"
                          hide-default-footer
                        >
                          <template v-slot:[`item.name`]="{ item }">
                            <div
                              style="
                                width: 120px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.name }}
                            </div>
                          </template>
                          <template v-slot:[`item.person_type`]="{ item }">
                            <div
                              style="
                                width: 70px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{
                                item.person_type == 1
                                  ? 'Karyawan'
                                  : item.person_type == 2
                                  ? 'Non Karyawan'
                                  : '-'
                              }}
                            </div>
                          </template>
                          <template v-slot:[`item.age`]="{ item }">
                            <div
                              style="
                                width: 70px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ calculateAge(item.birth_date) }}th
                            </div>
                          </template>
                          <template v-slot:[`item.gender`]="{ item }">
                            <div
                              style="
                                width: 70px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{
                                item.gender == 1
                                  ? 'Laki-laki'
                                  : item.gender == 2
                                  ? 'Perempuan'
                                  : '-'
                              }}
                            </div>
                          </template>
                          <template v-slot:[`item.injured_category`]="{ item }">
                            <div
                              style="
                                width: 80px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{
                                item.injured_category != null
                                  ? item.injured_category.name
                                  : '-'
                              }}
                            </div>
                          </template>
                          <template v-slot:[`item.body_part`]="{ item }">
                            <div
                              style="
                                width: 70px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{
                                item.body_part != null
                                  ? item.body_part.name
                                  : '-'
                              }}
                            </div>
                          </template>
                          <template v-slot:[`item.machine_used`]="{ item }">
                            <div
                              style="
                                width: 80px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.machine_used }}
                            </div>
                          </template>
                          <template v-slot:[`item.amount_loss`]="{ item }">
                            <div
                              style="
                                width: 60px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.amount_loss }}
                            </div>
                          </template>
                          <template
                            v-slot:[`item.rehabilitation_days`]="{ item }"
                          >
                            <div
                              style="
                                width: 60px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.rehabilitation_days }}
                              {{ item.engagement_type == 1 ? ' Hari' : '' }}
                            </div>
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <div
                              style="
                                width: 15px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                              "
                            >
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    color="error"
                                    @click.stop="deletePersonInvolve(item)"
                                  >
                                    mdi-delete
                                  </v-icon>
                                </template>
                                <span>Delete</span>
                              </v-tooltip>
                            </div>
                          </template>
                          <template v-slot:[`item.company_name`]="{ item }">
                            <div
                              style="
                                min-width: 180px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.company_name }}
                            </div>
                          </template>
                          <template v-slot:[`item.department_name`]="{ item }">
                            <div
                              style="
                                min-width: 180px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.department_name }}
                            </div>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-col>
                    <v-col cols="12">
                      <v-card elevation="1" class="mt-10 mb-5">
                        <div
                          class="d-flex"
                          style="
                            position: absolute;
                            top: -19px;
                            left: 2px;
                            z-index: 3;
                          "
                        >
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 13px;
                              font-weight: bold;
                              text-transform: uppercase;
                            "
                          >
                            Bangunan/Mesin/alat yang rusak
                          </p>
                        </div>
                        <v-data-table
                          mobile-breakpoint="0"
                          fixed-header
                          :items="detailData.damaged_object"
                          :headers="objectHeaders"
                          @click:row="brokenObjectRowClick"
                          style="cursor: pointer"
                          :loading="loading"
                          :items-per-page="-1"
                          hide-default-footer
                        >
                          <template v-slot:[`item.name`]="{ item }">
                            <div
                              style="
                                width: 120px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.name }}
                            </div>
                          </template>
                          <template v-slot:[`item.qty`]="{ item }">
                            <div
                              style="
                                width: 60px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.qty }}
                            </div>
                          </template>
                          <template v-slot:[`item.uom_name`]="{ item }">
                            <div
                              style="
                                width: 70px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.uom_id != null ? item.uom_name : '-' }}
                            </div>
                          </template>
                          <template v-slot:[`item.category`]="{ item }">
                            <div
                              style="
                                width: 80px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{
                                item.object_category != null
                                  ? item.object_category.name
                                  : '-'
                              }}
                            </div>
                          </template>
                          <template v-slot:[`item.description`]="{ item }">
                            <div
                              style="
                                width: 210px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.description }}
                            </div>
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <div
                              style="
                                width: 15px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                              "
                            >
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    color="error"
                                    @click.stop="deleteBrokenObject(item)"
                                  >
                                    mdi-delete
                                  </v-icon>
                                </template>
                                <span>Delete</span>
                              </v-tooltip>
                            </div>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
                <div
                  v-else-if="index == 2"
                  style="min-height: 40vh; margin-top: 15px"
                >
                  <v-row>
                    <v-col cols="12" md="3">
                      <p
                        class="text-left"
                        style="
                          padding-top: 10px;
                          font-size: 13px;
                          font-weight: bold;
                          text-transform: uppercase;
                        "
                      >
                        P2K3 / Ahli K3
                      </p>
                    </v-col>

                    <v-col cols="12" md="7">
                      <v-checkbox
                        v-model="detailData.has_p2k3"
                        :readonly="!isEdit"
                        style="margin: 0 0 0 10px"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="3">
                      <p
                        class="text-left"
                        style="
                          padding-top: 10px;
                          font-size: 13px;
                          font-weight: bold;
                          text-transform: uppercase;
                        "
                      >
                        BPJSTK
                      </p>
                    </v-col>

                    <v-col cols="12" md="7">
                      <v-checkbox
                        v-model="detailData.has_bpjstk"
                        :readonly="!isEdit"
                        style="margin: 0 0 0 10px"
                      ></v-checkbox>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="3">
                      <p
                        class="text-left"
                        style="
                          padding-top: 10px;
                          font-size: 13px;
                          font-weight: bold;
                          text-transform: uppercase;
                        "
                      >
                        Prosedur Keadaan Darurat
                      </p>
                    </v-col>

                    <v-col cols="12" md="7">
                      <v-checkbox
                        v-model="detailData.has_emergency_procedure"
                        :readonly="!isEdit"
                        style="margin: 0 0 0 10px"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </div>
                <div
                  v-else-if="index == 3"
                  style="min-height: 40vh; margin-top: 15px"
                >
                  <v-card elevation="0">
                    <v-form
                      ref="inspectionReportFormRef"
                      :readonly="!isEdit"
                      @submit.prevent="saveForm"
                      style="margin: 10px 0"
                    >
                      <v-row>
                        <v-col cols="12" class="d-flex flex-column">
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Kondisi Berbahaya
                            <v-tooltip right color="primary" top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  color="primary"
                                  x-small
                                >
                                  mdi-information
                                </v-icon>
                              </template>
                              <span>
                                {{
                                  detailData.danger_condition != null
                                    ? detailData.danger_condition.description
                                    : null
                                }}
                              </span>
                            </v-tooltip>
                          </p>
                          <v-autocomplete
                            v-model="detailData.danger_condition"
                            :clearable="isEdit"
                            :outlined="isEdit"
                            :readonly="!isEdit"
                            :items="dropdown.dangercondition"
                            item-text="name"
                            item-value="id"
                            return-object
                            dense
                            style="height: 25px"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" class="d-flex flex-column">
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Tindakan Berbahaya
                            <v-tooltip right color="primary" top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  color="primary"
                                  x-small
                                >
                                  mdi-information
                                </v-icon>
                              </template>
                              <span>
                                {{
                                  detailData.danger_action != null
                                    ? detailData.danger_action.description
                                    : null
                                }}
                              </span>
                            </v-tooltip>
                          </p>
                          <v-autocomplete
                            v-model="detailData.danger_action"
                            :clearable="isEdit"
                            :outlined="isEdit"
                            :readonly="!isEdit"
                            :items="dropdown.dangeraction"
                            item-text="name"
                            item-value="id"
                            return-object
                            dense
                            style="height: 25px"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" class="d-flex flex-column">
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Sumber Kecelakaan
                            <v-tooltip right color="primary" top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  color="primary"
                                  x-small
                                >
                                  mdi-information
                                </v-icon>
                              </template>
                              <span>
                                {{
                                  detailData.accident_source != null
                                    ? detailData.accident_source.description
                                    : null
                                }}
                              </span>
                            </v-tooltip>
                          </p>
                          <v-autocomplete
                            v-model="detailData.accident_source"
                            :clearable="isEdit"
                            :outlined="isEdit"
                            :readonly="!isEdit"
                            :items="dropdown.accidentsource"
                            item-text="name"
                            item-value="id"
                            return-object
                            dense
                            style="height: 25px"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" class="d-flex flex-column">
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Tipe Kecelakaan
                            <v-tooltip right color="primary" top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  color="primary"
                                  x-small
                                >
                                  mdi-information
                                </v-icon>
                              </template>
                              <span>
                                {{
                                  detailData.accident_type != null
                                    ? detailData.accident_type.description
                                    : null
                                }}
                              </span>
                            </v-tooltip>
                          </p>
                          <v-autocomplete
                            v-model="detailData.accident_type"
                            :clearable="isEdit"
                            :outlined="isEdit"
                            :readonly="!isEdit"
                            :items="dropdown.accidenttype"
                            item-text="name"
                            item-value="id"
                            return-object
                            dense
                            style="height: 25px"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" class="d-flex flex-column">
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Proses Berbahaya
                          </p>
                          <v-text-field
                            v-model="detailData.dangerous_process_desc"
                            :clearable="isEdit"
                            :outlined="isEdit"
                            :readonly="!isEdit"
                            dense
                            style="height: 25px"
                          />
                        </v-col>
                        <v-col cols="12" class="d-flex flex-column">
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Fungsi sarana proteksi yang ada
                          </p>
                          <v-text-field
                            v-model="detailData.existing_function_protection"
                            :clearable="isEdit"
                            :outlined="isEdit"
                            :readonly="!isEdit"
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>
                </div>
                <div
                  v-else-if="index == 4"
                  style="min-height: 40vh; margin-top: 15px"
                >
                  <v-card elevation="0">
                    <v-form
                      ref="inspectionReportFormRef"
                      :readonly="!isEdit"
                      @submit.prevent="saveFormUraian"
                      style="margin: 10px 0"
                    >
                      <div v-for="item in dropdown.desccategory" :key="item.id">
                        <v-row v-if="item.id > 1 && item.id < 6">
                          <v-col
                            cols="12"
                            md="5"
                            class="d-flex justify-start align-center"
                          >
                            <p
                              class="text-left"
                              style="
                                margin: 0;
                                font-size: 12px;
                                font-weight: bold;
                                text-transform: uppercase;
                              "
                            >
                              {{ item.name }}
                            </p>
                          </v-col>

                          <v-col cols="12" md="7">
                            <v-textarea
                              v-model="item.category_description"
                              rows="1"
                              :auto-grow="true"
                              dense
                              outlined
                              style="font-size: 12px"
                              :clearable="isEdit"
                            />
                          </v-col>
                        </v-row>
                      </div>
                    </v-form>
                  </v-card>
                </div>
                <!-- kesimpujlan -->
                <div
                  v-else-if="index == 10"
                  style="min-height: 40vh; margin-top: 15px"
                >
                  <v-card elevation="0">
                    <v-form
                      :readonly="!isEdit"
                      ref="inspectionReportFormRef"
                      @submit.prevent="saveForm"
                      style="margin: 10px 0"
                    >
                      <div v-for="item in dropdown.desccategory" :key="item.id">
                        <v-row v-if="item.id == 8">
                          <v-col cols="12">
                            <div v-if="isEdit" style="overflow: hidden">
                              <!-- vue editor deprecated its causing DOMNodeInserted warning -->
                              <vue-editor
                                v-model="detailData.conclusion"
                                class="textEditor"
                              ></vue-editor>
                            </div>
                            <div v-else>
                              <div
                                v-if="detailData.conclusion"
                                v-html="detailData.conclusion"
                                style="
                                  padding: 15px;
                                  border: 1px solid rgba(0, 0, 0, 0.1);
                                "
                              ></div>
                              <v-card
                                v-else
                                flat
                                height="30vh"
                                style="
                                  display: flex;
                                  justify-content: center;
                                  align-items: center;
                                "
                              >
                                <v-toolbar-title class="overline">
                                  Data Not Found</v-toolbar-title
                                >
                              </v-card>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-form>
                  </v-card>
                </div>
                <!-- tindakan lebih lanjut -->
                <div
                  v-else-if="index == 5"
                  style="min-height: 40vh; margin-top: 15px"
                >
                  <v-card elevation="0">
                    <v-form
                      :readonly="!isEdit"
                      ref="inspectionReportFormRef"
                      @submit.prevent="saveForm"
                      style="margin: 10px 0"
                    >
                      <div v-for="item in dropdown.desccategory" :key="item.id">
                        <v-row v-if="item.id == 9">
                          <v-col cols="12" md="4" class="d-flex flex-column">
                            <p
                              class="text-left"
                              style="
                                margin: 0;
                                font-size: 12px;
                                font-weight: bold;
                                color: rgba(0, 0, 0, 0.5);
                              "
                            >
                              Due Date Perbaikan
                            </p>
                            <v-text-field
                              v-model="detailData.corrective_action_due_date"
                              dense
                              :clearable="isEdit"
                              :outlined="isEdit"
                              style="height: 35px"
                              type="date"
                            />
                          </v-col>
                          <v-col cols="12">
                            <div v-if="isEdit" style="overflow: hidden">
                              <!-- vue editor deprecated its causing DOMNodeInserted warning -->
                              <vue-editor
                                v-model="detailData.corrective_action_desc"
                                class="textEditor"
                              ></vue-editor>
                            </div>
                            <div v-else>
                              <div
                                v-if="detailData.corrective_action_desc"
                                v-html="detailData.corrective_action_desc"
                                style="
                                  padding: 15px;
                                  border: 1px solid rgba(0, 0, 0, 0.1);
                                "
                              ></div>
                              <v-card
                                v-else
                                flat
                                height="30vh"
                                style="
                                  display: flex;
                                  justify-content: center;
                                  align-items: center;
                                "
                              >
                                <v-toolbar-title class="overline">
                                  Data Not Found</v-toolbar-title
                                >
                              </v-card>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-form>
                  </v-card>
                </div>
                <!-- dokumentasi kejadian -->
                <div v-else-if="index == 6" style="min-height: 40vh">
                  <v-card elevation="0">
                    <v-card-text class="d-flex justify-center align-center">
                      <v-row>
                        <v-col
                          v-if="
                            detailData.file == null ||
                            detailData.file.length == 0
                          "
                          cols="12"
                          class="d-flex justify-center align-center"
                          style="padding: 0; min-height: 20vh"
                        >
                          <div
                            style="
                              padding: 0 10px;
                              color: grey;
                              font-weight: bold;
                              font-size: 14px;
                            "
                          >
                            BELUM ADA PHOTO
                          </div>
                        </v-col>

                        <v-col
                          v-else
                          cols="12"
                          style="min-height: 20vh"
                          class="d-flex"
                        >
                          <div
                            v-for="(item, index) in detailData.file"
                            :key="index"
                            style="
                              padding: 0;
                              height: 100px;
                              width: 100px;
                              background-color: black;
                              margin: 5px;
                              position: relative;
                              border: 2px solid black;
                              border-radius: 5px;
                            "
                          >
                            <v-img
                              :src="item.file"
                              :lazy-src="`https://picsum.photos/10/6?image=${
                                index * 5 + 10
                              }`"
                              style="
                                width: 100%;
                                height: 100%;
                                border-radius: 5px;
                                cursor: pointer;
                              "
                              class="grey lighten-2"
                              @click="openImage(item)"
                            >
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    color="grey lighten-5"
                                  ></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>

                            <div
                              v-if="detailData.status.id == 0 && !isEdit"
                              class="d-flex justify-center align-center"
                              style="
                                position: absolute;
                                bottom: 0;
                                right: 0;
                                height: 30px;
                                width: 30px;
                                background-color: red;
                                border: 1px solid black;
                                border-radius: 15px 0 0 0;
                              "
                            >
                              <v-btn
                                @click="
                                  deletePhoto(
                                    item.file.slice(
                                      item.file.lastIndexOf('/') + 1
                                    )
                                  )
                                "
                                rounded
                                small
                                elevation="0"
                                icon
                              >
                                <v-icon color="white">mdi-delete</v-icon>
                              </v-btn>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-divider
                      v-if="detailData.status.id == 0 && !isEdit"
                    ></v-divider>

                    <v-card-actions v-if="detailData.status.id == 0 && !isEdit">
                      <v-btn
                        elevation="0"
                        small
                        outlined
                        style="margin-right: auto"
                        :loading="loading"
                        color="primary"
                        @click="openUploadModal('upload')"
                      >
                        <v-icon small style="margin-right: 5px"
                          >mdi-upload</v-icon
                        >
                        <span :style="`font-weight: bold;`">Tambah File</span>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="error"
                        small
                        outlined
                        :loading="loading"
                        @click="deleteAllFile"
                      >
                        <v-icon small style="margin-right: 5px"
                          >mdi-delete</v-icon
                        >
                        <span :style="`font-weight: bold;`">Delete All</span>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </div>
                <!-- <div v-else-if="index == 8" style="min-height: 40vh">
                  <v-row no-gutters style="padding: 0">
                    <v-col md="12" style="padding: 0">
                      <v-data-table
                        mobile-breakpoint="0"
                        fixed-header
                        height="50vh"
                        :headers="approvalHeaders"
                        :items="
                          detailData.approval_matrix != null
                            ? detailData.approval_matrix
                            : []
                        "
                        :items-per-page="10"
                        class="elevation-1 mx-auto"
                        hide-default-footer
                      >
                        <template v-slot:[`item.document_no`]="{ item }">
                          <div style="width: 140px; font-size: 12px">
                            {{ item.document_no }}
                          </div>
                        </template>
                        <template v-slot:[`item.table_name`]="{ item }">
                          <div style="width: 140px; font-size: 12px">
                            {{ item.table_name }}
                          </div>
                        </template>
                        <template v-slot:[`item.approver_user`]="{ item }">
                          <div style="cursor: pointer" v-if="item">
                            <v-chip
                              label
                              outlined
                              small
                              style="
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                                border: 1px solid rgba(0, 0, 0, 0.5);
                              "
                              v-for="(item, index) in item.approver_user"
                              :key="index"
                            >
                              {{ item.user !== null ? item.user.name : '-' }}
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:[`item.approved`]="{ item }">
                          <div
                            v-for="(items, index) in item.approver_user"
                            :key="index"
                            style="width: 140px"
                          >
                            <v-chip
                              v-if="items.status === 1"
                              label
                              outlined
                              small
                              style="
                                position: relative;
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                                border: 1px solid rgba(0, 0, 0, 0.5);
                              "
                            >
                              {{ item.user !== null ? items.user.name : '-' }}
                              <v-tooltip bottom color="primary">
                                <template v-slot:activator="{ attrs, on }">
                                  <div
                                    v-if="items.note"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="openCommentDialog(items)"
                                    style="
                                      position: absolute;
                                      top: 0;
                                      right: 0;
                                      width: 20px;
                                      bottom: 0;
                                      background: white;
                                    "
                                  >
                                    <v-icon small color="info"
                                      >mdi-comment-alert</v-icon
                                    >
                                  </div>
                                </template>
                                <span>Klik untuk melihat catatan</span>
                              </v-tooltip>
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:[`item.rejected`]="{ item }">
                          <div
                            v-for="(items, index) in item.approver_user"
                            :key="index"
                            style="width: 140px"
                          >
                            <v-chip
                              v-if="items.status === -1"
                              label
                              outlined
                              small
                              style="
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                              "
                            >
                              {{ item.user !== null ? items.user.name : '-' }}
                              <v-tooltip bottom>
                                <template v-slot:activator="{ attrs, on }">
                                  <div
                                    v-if="items.note"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="openCommentDialog(items)"
                                    style="
                                      position: absolute;
                                      top: 0;
                                      right: 0;
                                      width: 20px;
                                      bottom: 0;
                                      background: white;
                                    "
                                  >
                                    <v-icon small color="info"
                                      >mdi-comment-alert</v-icon
                                    >
                                  </div>
                                </template>
                                <span>Klik untuk melihat catatan</span>
                              </v-tooltip>
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:[`item.created_at`]="{ item }">
                          <div style="width: 140px; font-size: 12px">
                            {{ item.created_at }}
                          </div>
                        </template>
                        <template v-slot:[`item.updated_at`]="{ item }">
                          <div
                            v-for="(items, index) in item.approver_user"
                            :key="index"
                            style="width: 140px; font-size: 12px"
                          >
                            <span v-if="items.status === 1">
                              {{
                                items.updated_at !== null
                                  ? items.updated_at
                                  : '-'
                              }}
                            </span>
                            <br v-if="index > 0" />
                          </div>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <div
                    v-if="
                      getUserProfile.level.find(
                        ({ id }) =>
                          id == appLevel.adminK3 ||
                          id == appLevel.picK3 ||
                          id == appLevel.administrator
                      ) !== undefined
                    "
                  >
                    <div
                      style="text-align: left; padding-left: 5px"
                      v-if="detailData.status.id == 1"
                    >
                      <v-btn
                        color="grey"
                        tile
                        dark
                        small
                        dense
                        style="font-size: 10px; width: 100px; margin-top: 10px"
                        :loading="loading"
                        @click="fetchMatrix"
                      >
                        <span>Fetch Matrix</span>
                      </v-btn>
                    </div>
                  </div>
                </div> -->
                <div v-else style="min-height: 40vh; margin-top: 15px"></div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
        <BrokenObjectForm
          @loadPage="getDataFromApi"
          @saveBrokenObject="saveBrokenObject"
          :brokenObjectUpdateForm="brokenObjectUpdateForm"
          :inspectionreport="detailData"
        />
        <!-- <v-dialog v-model="commentDialog" width="500" persistent>
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Catatan Approval
            </v-card-title>

            <v-card-text class="d-flex justify-center align-center">
              <v-col md="12" style="padding: 0; position: relative; top: 20px">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      style="margin: 0; font-weight: bold"
                      v-if="commentNote != null"
                    >
                      {{ commentNote.note }}
                    </p>
                  </v-col>
                </div>
              </v-col>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn color="error" text outlined @click="closeCommentDialog">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
      </div>

      <!-- <v-card
        v-else
        flat
        height="90vh"
        style="display: flex; justify-content: center; align-items: center"
      >
        <v-toolbar-title class="overline"> Data Not Found</v-toolbar-title>
      </v-card> -->
    </div>
    <div v-else>
      <v-card
        class="mx-auto"
        width="100%"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          position: relative;
          top: 0;
          height: 70vh;
          left: 0;
          right: 0;
          background: rgba(255, 255, 255);
        "
      >
        <v-progress-circular :size="100" :width="5" color="blue" indeterminate
          >Loading...</v-progress-circular
        >
      </v-card>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import buildType from '../../../../../services/buildType'
import moment from 'moment'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'inspectionreportdetail',
  props: ['initialreport', 'appLevel', 'getdropdown'],
  components: {
    BrokenObjectForm: () => import('./components/BrokenObjectForm.vue')
  },
  data() {
    return {
      config: require('../../../../../services/config.json')[env],
      build: process.env.VUE_APP_BUILD_TYPE,
      oAuthApi: buildType.apiURL('oauth'),
      dssApi: buildType.apiURL('dss'),
      eSanqua: buildType.apiURL('esanqua'),
      // hrsApi: buildType.apiURL('hrs'),
      detailData: null,
      isEdit: false,
      isLoadingPage: true,
      loading: false,
      isDisableCompanyDropdown: false,
      skeleton_loading: true,

      rules: {
        nameRules: [],
        docRules: [],
        subjectRules: []
      },
      dropdown: {
        company: [],
        desccategory: [],
        accidentclassification: [],
        dangercondition: [],
        dangeraction: [],
        accidentsource: [],
        accidenttype: []
      },

      tab: null,
      panel: [],
      // documentationItems: [],
      victimData: [],
      witnessData: [],
      objectData: [],
      personInvolveUpdateForm: null,
      brokenObjectUpdateForm: null,
      isAllowApprove: false,
      commentDialog: false,
      commentNote: null
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  async mounted() {
    // if (this.initialreport.inspection_report != null) {
    //   this.initDataForLayout()
    // }

    if (this.inspectionSection.length > 0) {
      for (let i = 0; i < this.inspectionSection.length; i++) {
        this.panel.push(i)
      }
    }
  },
  computed: {
    ...mapGetters(['getUserProfile']),
    victimHeaders() {
      const arrHeaders = [
        {
          text: 'Nama',
          value: 'name'
        },
        {
          text: 'Tgl. Lahir',
          value: 'birth_date'
        },
        {
          text: 'Usia',
          value: 'age'
        },
        {
          text: 'Jenis Kelamin',
          value: 'gender'
        },
        {
          text: 'No. KTP',
          value: 'no_identitas'
        },
        {
          text: 'Status',
          value: 'person_type'
        },
        {
          text: 'Kategori',
          value: 'injured_category'
        },
        {
          text: 'Bagian Cidera',
          value: 'body_part'
        },
        {
          text: 'Mesin Digunakan',
          value: 'machine_used'
        },
        {
          text: 'Kerugian',
          value: 'amount_loss'
        },
        {
          text: 'Rehab',
          value: 'rehabilitation_days'
        },
        {
          text: 'Perusahaan',
          value: 'company_name'
        },
        {
          text: 'Department',
          value: 'department_name'
        },
        {
          text: 'Atasan',
          value: 'employee_leader_name'
        }
      ]
      if (
        this.detailData.status != null &&
        this.detailData.status.id == 0 &&
        !this.isEdit
      ) {
        arrHeaders.unshift({
          text: '',
          value: 'action'
        })
      }
      return arrHeaders
    },
    witnessHeaders() {
      const arrHeaders = [
        {
          text: 'Nama',
          value: 'name'
        },
        {
          text: 'Tgl. Lahir',
          value: 'birth_date'
        },
        {
          text: 'Usia',
          value: 'age'
        },
        {
          text: 'Jenis Kelamin',
          value: 'gender'
        },
        {
          text: 'No. KTP',
          value: 'no_identitas'
        },
        {
          text: 'Status',
          value: 'person_type'
        },
        {
          text: 'Perusahaan',
          value: 'company_name'
        },
        {
          text: 'Department',
          value: 'department_name'
        }
      ]
      if (
        this.detailData.status != null &&
        this.detailData.status.id == 0 &&
        !this.isEdit
      ) {
        arrHeaders.unshift({
          text: '',
          value: 'action'
        })
      }
      return arrHeaders
    },
    objectHeaders() {
      const arrHeaders = [
        {
          text: 'Nama',
          value: 'name'
        },
        {
          text: 'Kategori',
          value: 'category'
        },
        {
          text: 'Qty',
          value: 'qty'
        },
        {
          text: 'Satuan',
          value: 'uom_name'
        },
        {
          text: 'Keterangan',
          value: 'description'
        }
      ]
      if (
        this.detailData.status != null &&
        this.detailData.status.id == 0 &&
        !this.isEdit
      ) {
        arrHeaders.unshift({
          text: '',
          value: 'action'
        })
      }
      return arrHeaders
    },
    inspectionSection() {
      const xArr = [
        'Informasi Kecelakaan Kerja atau Keadaan Darurat',
        'Data Saksi & Korban',
        'Lain-lain',
        'Fakta yang Didapatkan',
        'Uraian terjadinya kecelakaan atau keadaan darurat'
        // 'Kesimpulan',
        // 'Tindakan lebih lanjut (rekomendasi P2K3 dan langkah-langkah yang telah diambil perusahaan)',
        // 'Dokumentasi kejadian/Lokasi kejadian/Pemeriksaan dan pengkajian'
        // 'Approval'
      ]
      return xArr
    }
    // approvalHeaders() {
    //   const arrHeaders = [
    //     { text: 'Seq', value: 'sequence', align: 'left' },
    //     { text: 'Doc. No', value: 'document_no', align: 'left' },
    //     { text: 'Model', value: 'table_name', align: 'center' },
    //     { text: 'User', value: 'approver_user', align: 'center' },
    //     {
    //       text: 'Min Acc',
    //       value: 'min_approver',
    //       align: 'center'
    //     },
    //     {
    //       text: 'Approved',
    //       value: 'approved',
    //       align: 'center'
    //     },
    //     {
    //       text: 'Rejected',
    //       value: 'rejected',
    //       align: 'center'
    //     },
    //     {
    //       text: 'CreatedAt',
    //       value: 'created_at',
    //       align: 'center'
    //     },
    //     {
    //       text: 'UpdateAt',
    //       value: 'updated_at',
    //       align: 'center'
    //     }
    //   ]
    //   return arrHeaders
    // }
  },
  watch: {},
  methods: {
    async initDropdown() {
      this.getDropdownAccidentDesc()
      this.getDropdowAccidentClassification()
      this.getDropdowAccidentType()
      this.getDropdownAccidentSource()
      this.getDropdownDangerAction()
      this.getDropdownDangerCondition()
    },
    async getDataFromApi() {
      if (this.initialreport.inspection_report != null) {
        this.loading = true
        const url = `${this.dssApi}inspectionreport/detail/${this.initialreport.inspection_report.id}`
        // console.log('inspectionreport.getDataFromApi >>>', url)
        await axios
          .get(url)
          .then((res) => {
            console.log('Detaill >>>', res)
            if (res.data.status_code == '00') {
              this.loading = false
              this.detailData = res.data.data
              if (this.detailData.investigation_date != null) {
                this.detailData.investigation_date = moment(
                  this.detailData.investigation_date
                ).format('YYYY-MM-DD')
              }
              // if (this.detailData.corrective_action_due_date != null) {
              //   this.detailData.corrective_action_due_date = moment(
              //     this.detailData.corrective_action_due_date
              //   ).format('YYYY-MM-DD')
              // }
              // if (res.data.data.status.id == 1) {
              //   this.authorityCheck(res.data.data);
              // }
              this.initDropdown()
              this.getDataSaksiKorban()
            } else {
              this.loading = false
            }
          })
          .catch((err) => {
            console.log(err)
            this.loading = false
          })
      } else {
        // console.log(
        //   'Detaill Inspection>>>',
        //   this.initialreport.inspection_report
        // )
      }
    },
    getDataSaksiKorban() {
      this.witnessData = this.initialreport.person_involve.filter(
        (person) => person.engagement_type == 2
      )
      this.victimData = this.initialreport.person_involve.filter(
        (person) => person.engagement_type == 1
      )
    },
    enableEdit() {
      this.isEdit = !this.isEdit

      if (!this.isEdit) {
        this.getDataFromApi()
      }
    },
    saveForm() {
      const exclude = [
        'created_at',
        'created_by',
        'created_by_name',
        'updated_at',
        'updated_by',
        'updated_by_name',
        'damaged_object',
        'initialreport_id',
        'status',
        'file',
        'document_no',
        'accident_item_desc',
        'initialreport'
      ]
      // Build form object by filtering out excluded fields and null values
      const form = Object.keys(this.detailData)
        .filter((key) => !exclude.includes(key) && this.detailData[key] != null)
        .reduce((obj, key) => {
          obj[key] = this.detailData[key]
          return obj
        }, {})
      console.log('gform>>>', form)

      this.createNewForm(form)
    },
    createNewForm(oldForm) {
      const xNewForm = {
        act: 'update',
        id: this.detailData.id,
        investigation_date: oldForm.investigation_date ?? undefined,
        total_missing_hours: oldForm.total_missing_hours
          ? +oldForm.total_missing_hours
          : undefined,
        total_working_hours: oldForm.total_working_hours
          ? +oldForm.total_working_hours
          : undefined,
        has_p2k3: oldForm.has_p2k3,
        has_bpjstk: oldForm.has_bpjstk,
        has_emergency_procedure: oldForm.has_emergency_procedure,
        existing_function_protection: oldForm.existing_function_protection,
        dangerous_process_desc: oldForm.dangerous_process_desc
        // conclusion: oldForm.conclusion,
        // corrective_action_due_date: oldForm.corrective_action_due_date,
        // corrective_action_desc: oldForm.corrective_action_desc
      }

      // Map object fields to their id if present
      const idFields = [
        {
          key: 'accident_classification',
          target: 'accident_classification_id'
        },
        { key: 'danger_condition', target: 'danger_condition_id' },
        { key: 'danger_action', target: 'danger_action_id' },
        { key: 'accident_source', target: 'accident_source_id' },
        { key: 'accident_type', target: 'accident_type_id' }
      ]

      idFields.forEach(({ key, target }) => {
        if (oldForm[key]?.id) xNewForm[target] = oldForm[key].id
      })

      // console.log('Final Form>>>', xNewForm)
      if (
        xNewForm.accident_classification_id == undefined ||
        xNewForm.accident_classification_id == null
      ) {
        return this.showMsgDialog(
          'warning',
          'Klasifikasi Kecelakaan Harus Diisi',
          false
        )
      }
      this.submitForm(xNewForm)
      this.saveFormUraian()
    },
    async submitForm(form) {
      this.loading = true
      // console.log(form)
      await axios
        .post(`${this.dssApi}inspectionreport/save`, form)
        .then(async (res) => {
          this.loading = false
          // console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.enableEdit()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          this.loading = false
          // console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },

    getDropdownAccidentDesc() {
      const url = `${this.dssApi}master/universal/desccategory/dropdown?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            // console.log(res.data.data)
            this.dropdown.desccategory = res.data.data
            const xArrItemDesc = this.detailData.accident_item_desc
            for (let i = 0; i < this.dropdown.desccategory.length; i++) {
              if (i < 6) {
                const itemDesc = xArrItemDesc.find(
                  ({ desc_category }) =>
                    desc_category.id == this.dropdown.desccategory[i].id
                )
                this.dropdown.desccategory[i].category_description =
                  itemDesc != null ? itemDesc.description : null
              }
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getDropdowAccidentClassification() {
      const url = `${this.dssApi}master/universal/accidentclassification/dropdown?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            // console.log(res.data.data)
            this.dropdown.accidentclassification = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getDropdownDangerCondition() {
      const url = `${this.dssApi}master/universal/dangercondition/dropdown?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            // console.log(res.data.data)
            this.dropdown.dangercondition = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getDropdownDangerAction() {
      const url = `${this.dssApi}master/universal/dangeraction/dropdown?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            // console.log(res.data.data)
            this.dropdown.dangeraction = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getDropdownAccidentSource() {
      const url = `${this.dssApi}master/universal/accidentsource/dropdown?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            // console.log(res.data.data)
            this.dropdown.accidentsource = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getDropdowAccidentType() {
      const url = `${this.dssApi}master/universal/accidenttype/dropdown?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            // console.log(res.data.data)
            this.dropdown.accidenttype = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    submitReportDocument() {
      console.log(this.detailData)

      if (this.detailData.accident_classification == null) {
        return this.showMsgDialog(
          'warning',
          'Klasifikasi kecelakaan wajib diisi',
          true
        )
      }
      if (this.detailData.investigation_date == null) {
        return this.showMsgDialog(
          'warning',
          'Tanggal pemeriksaan wajib diisi',
          true
        )
      }
      // if (this.detailData.total_working_hours == null) {
      //   return this.showMsgDialog(
      //     'warning',
      //     'Jumlah jam kerja perhari wajib diisi',
      //     true
      //   )
      // }
      this.showMsgDialog(
        'question',
        'Anda yakin ingin submit dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.detailData.id
          }
          axios
            .post(`${this.dssApi}inspectionreport/submit`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                // this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetchMatrix()
                // } else {
                this.getDataFromApi()
                this.$emit('loadPage')
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    cancelReportDocument() {
      this.showMsgDialog2(
        'question',
        'Anda yakin ingin cancel dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.detailData.id,
            note: res.value
          }
          axios
            .post(`${this.dssApi}inspectionreport/cancel`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                // this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
                this.$emit('loadPage')
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetch()
                //   console.log('fetch done')
                // } else {
                //   this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    setDraftReport() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin SET DRAFT dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.detailData.id
            // note: res.value
          }
          axios
            .post(`${this.dssApi}inspectionreport/set_to_draft`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                // this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
                this.$emit('loadPage')
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetch()
                //   console.log('fetch done')
                // } else {
                //   this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    // confirmReportDocument() {
    //   this.showMsgDialog2('question', 'Confirm dokumen ini ?', true).then(
    //     async (res) => {
    //       if (res.isConfirmed) {
    //         this.loading = true;
    //         const form = {
    //           document_id: this.detailData.id,
    //           note: res.value
    //         };
    //         axios
    //           .post(`${this.dssApi}inspectionreport/approve`, form)
    //           .then(async (res) => {
    //             this.loading = false;
    //             if (res.data.status_code == '00') {
    //               this.showMsgDialog('success', res.data.status_msg, false);
    //               this.getDataFromApi();
    //               this.$emit('loadPage');
    //             } else {
    //               this.showMsgDialog('warning', res.data.status_msg, false);
    //             }
    //           })
    //           .catch((err) => {
    //             this.showMsgDialog('error', err, false);
    //             this.loading = false;
    //           });
    //       }
    //     }
    //   );
    // },
    // rejectReportDocument() {
    //   this.showMsgDialog2('question', 'Reject dokumen ini ?', true).then(
    //     async (res) => {
    //       if (res.isConfirmed) {
    //         this.loading = true;
    //         const form = {
    //           document_id: this.detailData.id,
    //           note: res.value
    //         };
    //         axios
    //           .post(`${this.dssApi}inspectionreport/reject`, form)
    //           .then(async (res) => {
    //             this.loading = false;
    //             if (res.data.status_code == '00') {
    //               this.showMsgDialog('success', res.data.status_msg, false);
    //               this.getDataFromApi();
    //               this.$emit('loadPage');
    //             } else {
    //               this.showMsgDialog('warning', res.data.status_msg, false);
    //             }
    //           })
    //           .catch((err) => {
    //             this.showMsgDialog('error', err, false);
    //             this.loading = false;
    //           });
    //       }
    //     }
    //   );
    // },
    // authorityCheck(item) {
    //   if (item.approval_matrix !== null) {
    //     const matrixId = item.approval_matrix[0].document_id;
    //     axios
    //       .get(
    //         `${this.oAuthApi}approval_matrix/document/allow_user?document_id=${matrixId}&application_id=23`
    //       )
    //       .then((res) => {
    //         console.log('AuthorityCheck>>>', res);

    //         if (res.data.status_code === '00') {
    //           if (res.data.is_allow_approve !== 0) {
    //             this.isAllowApprove = true;
    //           } else {
    //             this.isAllowApprove = false;
    //           }
    //         } else {
    //           this.isAllowApprove = false;
    //         }
    //       })
    //       .catch((err) => {
    //         this.showMsgDialog(
    //           'error',
    //           err
    //             ? 'Cek Otoritas error, Silahkan info ke Admin'
    //             : 'Cek Otoritas error, Silahkan info ke Admin',
    //           false
    //         );
    //       });
    //   }
    // },
    // async fetchMatrix() {
    //   this.loading = true;
    //   const form = {
    //     id: this.detailData.id
    //     // approval_matrix_id: this.detailData.approval_matrix[0].document_id
    //   };
    //   await axios
    //     .post(`${this.dssApi}inspectionreport/fetch_matrix`, form)
    //     .then(async (res) => {
    //       if (res.data.status_code == '00') {
    //         if (res.data.approval_matrix_result.status_code == '00') {
    //           this.getDataFromApi();
    //         } else {
    //           this.showMsgDialog(
    //             'warning',
    //             res.data.approval_matrix_result.status_msg,
    //             false
    //           );
    //         }
    //       } else {
    //         this.showMsgDialog('error', res.data.status_msg, false);
    //       }
    //       this.loading = false;
    //       this.showMsgDialog(
    //         res.data.status_code == '00' ? 'success' : 'warning',
    //         res.data.status_msg,
    //         false
    //       );
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       this.loading = false;
    //     });
    // },
    deletePersonInvolve(pItem) {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted permanently',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          await axios
            .delete(
              `${this.dssApi}initialreport/personinvolve/delete/${pItem.id}`
            )
            .then(async (res) => {
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
                this.$emit('loadPage')
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    personInvovleRowClick(pItem) {
      if (!this.isEdit) {
        var objGender = null
        var objPersonType = null
        var objEngagementType = null
        var objEmployeeLeader = null
        var objCompany = null
        var objDepartment = null
        if (pItem.gender != null) {
          if (pItem.gender == 1) {
            objGender = {
              id: pItem.gender,
              name: 'Laki-laki'
            }
          }
          if (pItem.gender == 2) {
            objGender = {
              id: pItem.gender,
              name: 'Perempuan'
            }
          }
        }
        if (pItem.person_type != null) {
          if (pItem.person_type == 1) {
            objPersonType = {
              id: pItem.person_type,
              name: 'Karyawan'
            }
          }
          if (pItem.person_type == 2) {
            objPersonType = {
              id: pItem.person_type,
              name: 'Non Karyawan'
            }
          }
        }
        if (pItem.engagement_type != null) {
          if (pItem.engagement_type == 1) {
            objEngagementType = {
              id: pItem.engagement_type,
              name: 'Korban'
            }
          }
          if (pItem.engagement_type == 2) {
            objEngagementType = {
              id: pItem.engagement_type,
              name: 'Saksi'
            }
          }
        }
        if (pItem.employee_leader_id != null) {
          objEmployeeLeader = {
            id: pItem.employee_leader_id,
            name: pItem.employee_leader_name
          }
        }

        if (pItem.company_id != null) {
          objCompany = {
            id: pItem.company_id,
            name: pItem.company_name
          }
        }
        if (pItem.department_id != null) {
          objDepartment = {
            id: pItem.department_id,
            name: pItem.department_name
          }
        }
        const formDataUpdate = {
          act: 'update',
          id: pItem.id,
          // initialreport_id: pItem.initialreport_id,
          name: pItem.name,
          birth_date: pItem.birth_date,
          gender: objGender,
          no_identitas: pItem.no_identitas,
          person_type: objPersonType,
          engagement_type: objEngagementType,
          employee_leader: objEmployeeLeader,
          injured_category: pItem.injured_category,
          injured_body_part_id: pItem.injured_body_part_id,
          machine_used: pItem.machine_used,
          amount_loss: pItem.amount_loss,
          rehabilitation_days: pItem.rehabilitation_days,
          company: objCompany,
          department: objDepartment
        }
        // console.log('formDataUpdate', formDataUpdate);
        this.$emit('handlePersonFromChild', formDataUpdate)
      }
    },
    addNewPersonInvolve() {
      this.$emit('handlePersonFromChild', null)
    },
    brokenObjectRowClick(pItem) {
      if (!this.isEdit) {
        // console.log('brokenObjectRowClick', pItem)
        const formDataUpdate = {
          act: 'update',
          id: pItem.id,
          // initialreport_id: pItem.initialreport_id,
          name: pItem.name,
          object_category: pItem.object_category,
          qty: pItem.qty,
          uom: {
            id: pItem.uom_id,
            name: pItem.uom_name
          },
          description: pItem.description
        }
        console.log('formDataUpdate', formDataUpdate)
      }
    },
    addNewBrokenObject() {
      setTimeout(() => {
        document.getElementById('brokenObjectForm').click()
      }, 200)
    },
    saveBrokenObject(data) {
      // console.log('inspectionreport.saveBrokenObject', data)
      if (data != null) {
        const form = {
          name: data.name,
          object_category_id:
            data.object_category != null ? data.object_category.id : undefined,
          uom_id: data.uom != null ? data.uom.id : undefined,
          uom_name: data.uom != null ? data.uom.name : undefined,
          qty: data.qty,
          description: data.description
        }

        if (data.act == 'add') {
          Object.assign(form, {
            act: data.act,
            inspection_id: this.detailData.id
          })
        }

        if (data.act == 'update') {
          Object.assign(form, {
            act: data.act,
            id: data.id
          })
        }
        // console.log('inspectionreport.finalForm', form)
        this.submitBrokenObject(form)
      } else {
        this.brokenObjectUpdateForm = null
      }
    },
    async submitBrokenObject(form) {
      this.loading = true
      // console.log(form)
      await axios
        .post(`${this.dssApi}inspectionreport/damagedobject/save`, form)
        .then(async (res) => {
          // console.log('brokenObject.submit', res.data)
          this.loading = false
          if (res.data.status_code == '00') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.brokenObjectUpdateForm = null
            this.getDataFromApi()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          this.loading = false
          // console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    deleteBrokenObject(pItem) {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted permanently',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          await axios
            .delete(
              `${this.dssApi}inspectionreport/damagedobject/delete/${pItem.id}`
            )
            .then(async (res) => {
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    saveFormUraian() {
      const list = this.dropdown.desccategory
      const xArrItemDesc = this.detailData.accident_item_desc
      for (let i = 0; i < list.length; i++) {
        if (i < 6) {
          const form = {
            description: this.dropdown.desccategory[i].category_description,
            desc_category_id: this.dropdown.desccategory[i].id
          }

          const itemDesc = xArrItemDesc.find(
            ({ desc_category }) =>
              desc_category.id == this.dropdown.desccategory[i].id
          )

          if (itemDesc != undefined && itemDesc != null) {
            Object.assign(form, {
              act: 'update',
              id: itemDesc.id
            })
          } else {
            Object.assign(form, {
              act: 'add',
              inspection_id: this.detailData.id
            })
          }

          if (
            form.description != undefined &&
            form.description != null &&
            form.description != ''
          ) {
            // console.log('save desc>>>', form)
            this.submitFormUraian(form)
          }
        }
      }
    },
    async submitFormUraian(form) {
      await axios
        .post(`${this.dssApi}inspectionreport/accidentdesc/save`, form)
        .then(async (res) => {
          if (res.data.status_code == '00') {
            return {
              status_code: '00',
              desc_category_id: form.desc_category_id
            }
          }

          return {
            status_code: '-99',
            desc_category_id: form.desc_category_id
          }
        })
        .catch((err) => {
          return {
            status_code: '-99',
            err_msg: `${err.message}`,
            desc_category_id: form.desc_category_id
          }
        })
    },

    // openUploadModal(event) {
    //   if (event === 'upload') {
    //     setTimeout(() => {
    //       this.uploadDialog = true
    //     }, 500)
    //   }
    //   if (event === 'close') {
    //     if (this.fileName !== '') {
    //       let fName = ''
    //       fName = this.fileName
    //       this.unlinkDokumen(fName, true)
    //       this.file_subject = null
    //       // this.$refs.uploadDoc.reset()
    //     }
    //     this.$refs.entryFormUpload.reset()
    //     setTimeout(() => {
    //       this.uploadDialog = false
    //     }, 500)
    //   }
    //   this.fileName = ''
    // },
    // deletePhoto(photoName) {
    //   this.showMsgDialog('question', 'Hapus photo, Anda yakin ?', true).then(
    //     async (res) => {
    //       if (res.isConfirmed) {
    //         this.unlinkDokumen(photoName)
    //       }
    //     }
    //   )
    // },
    // unlinkDokumen(fName, pValue) {
    //   // console.log('Unlink>>>', fName)
    //   this.loading = true
    //   const data = {
    //     module: 'k3',
    //     file_name: fName
    //   }
    //   axios
    //     .post(`${this.uploadApi}esanqua/dss/unlink`, data)
    //     .then((res) => {
    //       // console.log('Unlink>>>>>', res)
    //       if (res.data.status_code === '00') {
    //         this.fileName = ''
    //         if (pValue === undefined) {
    //           this.removeFileFromDetail(fName)
    //         }
    //       } else {
    //         this.showMsgDialog('warning', res.data.status_msg, false)
    //         if (pValue === undefined) {
    //           if (res.data.status_msg === 'File not found') {
    //             this.removeFileFromDetail(fName)
    //           }
    //         }
    //       }
    //       this.loading = false
    //     })
    //     .catch((err) => {
    //       this.loading = false
    //       this.showMsgDialog('error', err.message, false)
    //     })
    // },
    // removeFileFromDetail(fName) {
    //   // console.log('removeFileFromDetail>>', fName, this.detailData.file)
    //   for (let i = 0; i < this.detailData.file.length; i++) {
    //     if (this.detailData.file[i].file.includes(fName)) {
    //       this.detailData.file.splice(i, 1)
    //     }
    //   }
    //   // console.log('this.detailData.file after>>', this.detailData.file)
    //   this.updatePhoto(false)
    // },
    // uploadFile(event) {
    //   if (event !== null) {
    //     if (event.size <= 1024 * 1024 * 2) {
    //       // this.loading = true;
    //       const data = new FormData()
    //       data.append('file', event)
    //       data.append('module', 'k3')
    //       axios
    //         .post(`${this.uploadApi}esanqua/dss`, data)
    //         .then((res) => {
    //           if (res.data.status === true) {
    //             this.showMsgDialog(
    //               'success',
    //               'File siap disimpan, Silahkan lanjutkan dengan klik tombol "simpan file"',
    //               false
    //             )
    //             this.fileName = res.data.data.name
    //             // setTimeout(() => {
    //             //   this.submitUploadDoc()
    //             // }, 200)
    //           } else {
    //             this.showMsgDialog('warning', res.data.message, false)
    //           }
    //           // this.loading = false;
    //         })
    //         .catch((err) => {
    //           // this.loading = false;
    //           this.showMsgDialog('error', err.message, false)
    //         })
    //     } else {
    //       setTimeout(() => {
    //         this.showMsgDialog('warning', 'Max size = 2MB', false)
    //         this.fileName = ''
    //       }, 300)
    //     }
    //   } else {
    //     this.fileName = ''
    //     // this.$refs.uploadDoc.reset()
    //   }
    // },
    // submitUploadDoc() {
    //   this.rules.docRules = [(v) => !!v || 'Tidak ada file yang terupload']
    //   this.rules.subjectRules = [(v) => !!v || 'Kolom Subject diperlukan']
    //   const self = this
    //   setTimeout(function () {
    //     if (self.$refs.entryFormUpload.validate()) {
    //       self.updatePhoto(true)
    //     }
    //   })
    // },

    // async updatePhoto(isAddFile) {
    //   // this.loading = true
    //   // console.log('upload form>>>', this.detailData.file)
    //   const file = []
    //   if (this.detailData.file != null) {
    //     for (let i = 0; i < this.detailData.file.length; i++) {
    //       const fName = this.detailData.file[i].file.slice(
    //         this.detailData.file[i].file.lastIndexOf('/') + 1
    //       )
    //       file.push({
    //         subject: this.detailData.file[i].subject,
    //         file: fName
    //       })
    //     }
    //   }
    //   if (isAddFile) {
    //     file.push({
    //       subject: this.file_subject,
    //       file: this.fileName
    //     })
    //   }
    //   const form = {
    //     id: this.detailData.id,
    //     file: file
    //   }
    //   // console.log('upload form>>>', form)
    //   await axios
    //     .post(`${this.dssApi}upload/k3/update_file_upload`, form)
    //     .then((res) => {
    //       this.loading = false
    //       if (res.data.status_code === '00') {
    //         this.showMsgDialog('success', 'File berhasil disimpan', false)
    //         this.file_subject = null
    //         this.fileName = ''
    //         if (document.getElementById('closeFileUpload') != null) {
    //           document.getElementById('closeFileUpload').click()
    //         }
    //         this.detailData.file = []
    //         setTimeout(() => {
    //           for (let i = 0; i < file.length; i++) {
    //             this.detailData.file.push({
    //               subject: file[i].subject,
    //               file: 'http://10.10.20.8:8020/dss/k3/' + file[i].file
    //             })
    //           }
    //           // console.log('this.evidenceFile>>>>', this.evidenceFile);
    //           this.getDataFromApi()
    //         }, 300)
    //       } else {
    //         this.showMsgDialog('error', res.data.status_msg, false)
    //         this.unlinkDokumen(this.fileName)
    //       }
    //     })
    //     .catch((err) => {
    //       this.loading = false
    //       this.showMsgDialog('error', err.message, false)
    //       this.fileName = ''
    //       // this.$refs.entryFormUpload.reset()
    //     })
    // },

    // async deleteAllFile() {
    //   this.showMsgDialog(
    //     'question',
    //     'Semua file akan terhapus, Anda yakin ?',
    //     true
    //   ).then(async (res) => {
    //     if (res.isConfirmed) {
    //       // this.loading = true
    //       const arrFileName = []
    //       for (let i = 0; i < this.detailData.file.length; i++) {
    //         const fileName = this.detailData.file[i].file.slice(
    //           this.detailData.file[i].file.lastIndexOf('/') + 1
    //         )
    //         const data = {
    //           module: 'k3',
    //           file_name: fileName
    //         }
    //         await axios
    //           .post(`${this.uploadApi}esanqua/dss/unlink`, data)
    //           .then((res) => {
    //             // console.log(`Unlink-${i + 1}>>>`, res)
    //             if (res.data.status_code === '00') {
    //               arrFileName.push(fileName)
    //             }
    //             return null
    //           })
    //           .catch((err) => {
    //             console.log(`Err Unlink-${i + 1}>>>`, err)
    //             return null
    //           })
    //       }
    //       // console.log('deleteAll>>>>>', arrFileName)
    //       const form = {
    //         id: this.detailData.id,
    //         file: []
    //       }
    //       await axios
    //         .post(`${this.dssApi}upload/k3/update_file_upload`, form)
    //         .then((res) => {
    //           if (res.data.status_code === '00') {
    //             this.showMsgDialog('success', res.data.status_msg, false)
    //             this.getDataFromApi()
    //           } else {
    //             this.showMsgDialog('warning', res.data.status_msg, false)
    //           }
    //           this.loading = false
    //         })
    //         .catch((err) => {
    //           this.loading = false
    //           this.showMsgDialog('error', err.message, false)
    //         })
    //     }
    //   })
    // },
    // openImage(img) {
    //   this.imageLink = null

    //   this.imageLink = img.file
    //   this.image.width = 800
    //   this.image.height = 600
    //   this.image.deg = 0
    //   this.image.translate = ''
    //   this.image.origin = 'top left'
    //   setTimeout(() => {
    //     this.imageDialog = true
    //   }, 300)
    // },
    // imgError() {
    //   // console.log('error image')
    //   // this.isImgError = true
    //   this.imageLink =
    //     'https://e-sanqua.sanquawater.co.id/image/ecatalogue/products/photo_1/ProductPhoto-jahsors8yollrrbjwsyx7.png'
    // },
    // openCommentDialog(obj) {
    //   console.log(obj)
    //   this.commentNote = obj
    //   setTimeout(() => {
    //     this.commentDialog = true
    //   }, 100)
    // },
    // closeCommentDialog() {
    //   this.commentDialog = false
    //   setTimeout(() => {
    //     this.commentNote = null
    //   }, 100)
    // },
    calculateAge(birthDate) {
      const today = new Date()
      const birthDateObj = new Date(birthDate)
      let age = today.getFullYear() - birthDateObj.getFullYear()
      const monthDifference = today.getMonth() - birthDateObj.getMonth()

      // If the birthday hasn't occurred yet this year, subtract 1 from age
      if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthDateObj.getDate())
      ) {
        age--
      }

      return age
    },
    getBodyPartName(obj) {
      const xFindBodyPart = this.getdropdown.body_part.find((d) => d.id == obj)
      let xBodyPartName = '-'
      if (xFindBodyPart != undefined) {
        xBodyPartName = xFindBodyPart.name
      }

      return xBodyPartName
    },
    initialStatusColor(val) {
      if (val) {
        if (val.id == -1) {
          return 'red'
        } else {
          const arrColour = ['grey', 'green', 'red']
          return arrColour[val.id]
        }
      }
    },
    toRoman(num) {
      if (isNaN(num)) return ''

      const roman = [
        ['M', 1000],
        ['CM', 900],
        ['D', 500],
        ['CD', 400],
        ['C', 100],
        ['XC', 90],
        ['L', 50],
        ['XL', 40],
        ['X', 10],
        ['IX', 9],
        ['V', 5],
        ['IV', 4],
        ['I', 1]
      ]

      let result = ''
      for (const [symbol, value] of roman) {
        while (num >= value) {
          result += symbol
          num -= value
        }
      }
      return result
    },
    showMsgDialog2(pModalType, pStatusMsg, pBtnCancel, pText) {
      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              additional +
              '<br/>' +
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: 'Submit',
            cancelButtonText: 'No',
            input: 'textarea',
            inputLabel:
              'Tolong isi keterangan pada kolom dibawah sebelum submit',
            inputPlaceholder: 'Tulis disini...',
            inputAttributes: {
              'aria-label': 'Tulis disini'
            }
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel, yesBtn, noBtn, pText) {
      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>' +
              '<br/>' +
              additional,
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: yesBtn || 'OK',
            cancelButtonText: noBtn || 'NO'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },

    downloadImage() {
      const fileName = this.imageLink.slice(this.imageLink.lastIndexOf('/'))
      const link = document.createElement('a')
      link.target = '_blank'
      link.href = this.imageLink
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    rotateImage(str) {
      if (this.image.deg == -270 || this.image.deg == 270) {
        this.image.deg = 0
      } else {
        if (str == 'left') {
          this.image.deg = this.image.deg - 90
        }
        if (str == 'right') {
          this.image.deg = this.image.deg + 90
        }
      }
      // console.log(this.image.translate)
      if (this.image.translate == '') {
        this.image.width = 600
        this.image.height = 800
        // this.image.origin = 'top left'
        //   this.image.translate = 'translateY(-100%)'
      } else {
        this.image.width = 800
        this.image.height = 600
        // this.image.origin = ''
        //   this.image.translate = ''
      }
      // console.log(this.image.deg)
      if (
        this.image.deg == 0 ||
        this.image.deg == 180 ||
        this.image.deg == -180
      ) {
        this.image.translate = ''
        this.image.origin = ''
      }

      if (this.image.deg == -90 || this.image.deg == 270) {
        this.image.translate = 'translateX(-100%)'
        this.image.origin = 'top left'
      }
      if (this.image.deg == 90 || this.image.deg == -270) {
        this.image.translate = 'translateY(-100%)'
        this.image.origin = 'top left'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-scroll-wrapper {
  max-height: 73vh; /* Or whatever fits your layout */
  overflow-y: auto;
  position: relative;
  padding: 0 15px 0 15px;
  &::-webkit-scrollbar {
    // display: none;
    width: 4px;
    background: aquamarine;
  }
  &::-webkit-scrollbar-thumb {
    background: cornflowerblue;
  }
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 6;
}

// .step-content {
// padding: 10px;
// }
</style>
